import { AppService } from "app/services/app.service";

import { Observable } from "rxjs";

export abstract class AbConfigScondKey extends AppService {
  abstract getEventos(): Observable<any>;
}